import { Component, Input } from '@angular/core';

@Component({
    selector: 'btl-legals-text',
    templateUrl: './legals-text.component.html',
    styleUrls: ['./legals-text.component.scss'],
})
export class LegalsTextComponent {
    public legalsLoaded: boolean = false;

    @Input() public collapsedLegals: boolean = true;
    @Input() public title: string;
    @Input() public blockId: string;

    public mentionLoaded(e: any) {
        this.legalsLoaded = e;
    }
}
